namespace advisorop.components.common {

    enum viewType {
        summary,
        detail,
        accountOnly,
        pivotTable,
    };

    type linkTo = 'investor' | 'household' | 'account';
    const linkPath: Record<linkTo, string> = { investor: "/advisor/advisorinvestordashboard/", household: "/advisor/advisorhouseholddashboard/", account: "/advisor/accountsummary/" };
    const linkFunction: Record<linkTo, string> = { investor: "vm.goToInvestorDashboard", household: "vm.goToHouseholdDashboard", account: "vm.goToAccountSummary" };

    export class SelectFilterSecurityCodeController2 {

        dgAccountsOnlyOption: DevExpress.ui.dxDataGridOptions;
        dgAccountsOnly: DevExpress.ui.dxDataGrid;
        dgSummaryOptions: DevExpress.ui.dxDataGridOptions;
        dgSummary: DevExpress.ui.dxDataGrid;
        dgAllResultsOption: DevExpress.ui.dxDataGridOptions;
        dgAllResults: DevExpress.ui.dxDataGrid;
        pgAllResultsOptions: DevExpress.ui.dxPivotGridOptions;
        pgAllResults: DevExpress.ui.dxPivotGrid;
        onIAmReady: any;

        resetSearch: boolean = false;
        fields: Map<number, [any]> = new Map();

        boAccountDetails: Array<domains.IAccountBOAccountData> = [];
        accounts: Array<any> = [];
        boAccountPivotTableDetails: Array<domains.IAccountBOAccountPivotTableData> = [];
        loading: boolean = false;

        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#holdingsSearch" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading...",
            bindingOptions: {
                visible: "vm.loading"
            }
        };

        pgdsoAllResults: DevExpress.data.PivotGridDataSourceOptions = {
            fields: [{
                dataField: "usdMarketValue",
                area: "data",
                caption: "Market Value",
                dataType: "number",
                summaryType: "sum",
                format: "currency",
            }, {
                dataField: "households",
                area: "row",
                selector: function (data) {
                    var householdNames = "";
                    data.households.forEach(household => {
                        if (householdNames.length > 0) {
                            householdNames += ", ";
                        }
                        householdNames += household.name;
                    })
                    return householdNames;
                },
                areaIndex: 0
            }, {
                dataField: "accountName",
                area: "row",
                caption: "Account Name",
                dataType: "string",
                areaIndex: 1,
                width: 300
            }, {
                dataField: "investors",
                selector: function (data) {
                    var investorNames = "";
                    data.investors.forEach(investor => {
                        if (investorNames.length > 0) {
                            investorNames += ", ";
                        }
                        if (investor.investorType == domains.InvestorType.COMPANY) {
                            investorNames += investor.entityName;
                        } else {
                            investorNames += investor.firstName + " " + investor.lastName;
                        }
                    })
                    return investorNames;
                },
                },
                {
                    dataField: "companyName",
                    caption: "Company Name",
                    dataType: "string",
                    selector: function (data) {
                        return data.companyName?.length > 0 ? data.companyName : "No Comapny Name"
                    },
                },
                {
                    dataField: "managerName",
                    area: "column",
                    caption: "Manager Name",
                    dataType: "string",
                    selector: function (data) {
                        return data.managerName?.length > 0 ? data.managerName : "Non Manager"
                    },
                    areaIndex: 0
                },
                {
                dataField: "productName",
                area: "column",
                caption: "Product Name",
                dataType: "string",
                width: 200,
                    selector: function (data) {
                        return data.productName?.length > 0 ? data.productName : "Non Product"
                    },
                areaIndex: 1
                },
                {
                dataField: "securityName",
                area: "column",
                caption: "Security Name",
                dataType: "string",
                width: 400,
                    selector: function (data) {
                        return data.securityName?.length > 0 ? data.securityName : "Non Security"
                    },
                areaIndex: 2
            },
            ],
            store: this.boAccountPivotTableDetails,
        };

        selectedSecurityProduct: domains.ISecurityProductDetail;
        selectedSecurities: Array<string>;
        selectedProducts: Array<number>;
        selectedManagers: Array<number>;
        searchTerm: string;

        //mainPanel: advisorop.components.widgets.AdvisoropPanelController;

        isAdvisor: boolean = false;
        grouping = {
            autoExpandAll: false,
            allowCollapsing: true
        };

        currentViewType: viewType = viewType.detail;

        summarize: boolean = false;
        fullDetails: boolean = true;
        accountsOnly: boolean = false;

        static $inject = ["generalService", "identityService", "accountApi", "advisorService", "$rootScope", "$compile", "$scope"];
        constructor(
            private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private accountApi: services.AccountApi,
            private advisorService: services.AdvisorService,
            private $rootScope: ng.IRootScopeService,
            private $compile,
            private $scope: ng.IScope) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                if (this.selectedSecurityProduct) {
                    if (this.selectedSecurityProduct.uniqueSecId) {
                        this.loadAccountsBySecId();
                    } else {
                        this.loadAccountsByManagerProduct();
                    }
                } else if (this.searchTerm) {
                    this.loadAccountsBySearchTerm();
                }
                this.showAdvisorColumn(this.dgAccountsOnly);
                this.showAdvisorColumn(this.dgAllResults);
                this.showAdvisorColumn(this.dgSummary);
            });
        }

        setupDataGrids() {
            this.dgAccountsOnlyOption = {
                export: {
                    enabled: true,
                    fileName: "AccountsOnly",
                    customizeExcelCell: (options) => {
                        this.buildCustomExportCell(options);
                    }
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                paging: {
                    pageSize: 10,
                    enabled: true
                },
                columnChooser: {
                    enabled: true,
                    mode: "dragAndDrop",
                    title: "Select columns",
                    width: 300
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showRowLines: true,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    {
                        dataField: "accountName", caption: "Account", width: 300, cellTemplate: (cellElement, item) => {
                            var labelText = this.buildLink(item.data.accountId, item.data.accountName, item.data.accountNumber, item.data.advisorUserName, 'account');
                            $('<div>').html(labelText).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    },
                    { dataField: "accountNumber", caption: "Number", allowFiltering: true },
                    { dataField: "titleType", caption: "Type" },
                    { dataField: "companyName", caption: "Company Name" },
                    { dataField: "productDescription", caption: "Product Description", allowFiltering: true, width: 400 },
                    { dataField: "managerName", caption: "Manager", allowFiltering: true },
                    { dataField: "productName", caption: "Product Name", allowFiltering: true, width: 200 },
                    { dataField: "modelName", caption: "Model", allowFiltering: true },
                    { dataField: "securityName", caption: "Security", allowFiltering: true },
                    { dataField: "uniqueSecId", caption: "Security ID", allowFiltering: true },
                    { dataField: "usdMarketValue", caption: "Account Balance", format: "currency", allowHeaderFiltering: false },
                    { dataField: "marketValueDate", caption: "As of Date", dataType: "date", format: "MM/dd/yyyy", allowHeaderFiltering: false },
                    {
                        dataField: "advisorName", caption: "Advisor", visible: !this.isAdvisor, cellTemplate: (cellElement, item) => {
                            var labelText = this.buildAdvisorLink(item.data.advisorName, item.data.advisorUserName);
                            $('<div>').html(labelText).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }
                    },
                    {
                        caption: "Investors", cellTemplate: (cellElement, item) => {
                            var account: domains.IAccountBOAccountData = item.data;
                            var reducedLabel = account.investors.reduce((label, investor) => {
                                return label != "" ? label + ", " + this.buildLink(investor.id, investor.fullName, undefined, account.advisorUserName, 'investor') :
                                    this.buildLink(investor.id, investor.fullName, undefined, account.advisorUserName, 'investor');
                            }, "");
                            $('<div>').html(reducedLabel).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    },
                    {
                        caption: "Households", cellTemplate: (cellElement, item) => {
                            var account: domains.IAccountBOAccountData = item.data;
                            var reducedLabel = account.households.reduce((label, household) => {
                                return label != "" ? label + ", " + this.buildLink(household.id, household.name, undefined, account.advisorUserName, 'household') :
                                    this.buildLink(household.id, household.name, undefined, account.advisorUserName, 'household');
                            }, "");
                            $('<div>').html(reducedLabel).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    }
                ],
                onInitialized: e => {
                    this.dgAccountsOnly = e.component;
                    this.showAdvisorColumn(e.component);
                }
            }

            this.dgAllResultsOption = {
                export: {
                    enabled: true,
                    fileName: "AccountsFullDetails",
                    customizeExcelCell: (options) => {
                        this.buildCustomExportCell(options);
                    }
                },
                bindingOptions: {
                    dataSource: "vm.boAccountDetails"
                },
                paging: {
                    pageSize: 10,
                    enabled: true
                },
                columnChooser: {
                    enabled: true,
                    mode: "dragAndDrop",
                    title: "Select columns",
                    width: 300
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showRowLines: true,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    {
                        dataField: "accountName", caption: "Account", width: 300, cellTemplate: (cellElement, item) => {
                            var labelText = this.buildLink(item.data.accountId, item.data.accountName, item.data.accountNumber, item.data.advisorUserName, 'account');
                            $('<div>').html(labelText).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    },
                    { dataField: "accountNumber", caption: "Number", allowFiltering: true },
                    { dataField: "titleType", caption: "Type" },
                    { dataField: "companyName", caption: "Company Name" },
                    { dataField: "productDescription", caption: "Product Description", allowFiltering: true, width: 400 },
                    { dataField: "managerName", caption: "Manager", allowFiltering: true },
                    { dataField: "productName", caption: "Product Name", allowFiltering: true, width: 200 },
                    { dataField: "modelName", caption: "Model", allowFiltering: true },
                    { dataField: "securityName", caption: "Security", allowFiltering: true },
                    { dataField: "uniqueSecId", caption: "Security ID", allowFiltering: true },
                    { dataField: "usdMarketValue", caption: "Market Value", format: "currency", allowHeaderFiltering: false },
                    { dataField: "totalAUM", caption: "Account Balance", format: "currency", allowHeaderFiltering: false },
                    { dataField: "asOfDate", caption: "As of Date", dataType: "date", format: "MM/dd/yyyy", allowHeaderFiltering: false },
                    {
                        dataField: "advisorName", caption: "Advisor", visible: !this.isAdvisor, cellTemplate: (cellElement, item) => {
                            var labelText = this.buildAdvisorLink(item.data.advisorName, item.data.advisorUserName);
                            $('<div>').html(labelText).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }
                    },
                    {
                        caption: "Investors", cellTemplate: (cellElement, item) => {
                            var account: domains.IAccountBOAccountData = item.data;
                            var reducedLabel = account.investors.reduce((label, investor) => {
                                return label != "" ? label + ", " + this.buildLink(investor.id, investor.fullName, undefined, account.advisorUserName, 'investor') :
                                    this.buildLink(investor.id, investor.fullName, undefined, account.advisorUserName, 'investor');
                            }, "");
                            $('<div>').html(reducedLabel).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    },
                    {
                        caption: "Households", cellTemplate: (cellElement, item) => {
                            var account: domains.IAccountBOAccountData = item.data;
                            var reducedLabel = account.households.reduce((label, household) => {
                                return label != "" ? label + ", " + this.buildLink(household.id, household.name, undefined, account.advisorUserName, 'household') :
                                    this.buildLink(household.id, household.name, undefined, account.advisorUserName, 'household');
                            }, "");
                            $('<div>').html(reducedLabel).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    }
                ],
                onInitialized: e => {
                    this.dgAllResults = e.component;
                    this.showAdvisorColumn(e.component);
                }
            };

            this.dgSummaryOptions = {
                export: {
                    enabled: true,
                    fileName: "AccountsSummary"
                },
                bindingOptions: {
                    dataSource: "vm.boAccountDetails",
                    grouping: "vm.grouping"
                },
                paging: {
                    pageSize: 10,
                    enabled: true
                },
                rowAlternationEnabled: false,
                showBorders: true,
                showRowLines: true,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: true,
                    mode: "dragAndDrop",
                    title: "Select columns",
                    width: 300
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                groupPanel: {
                    visible: false
                },
                columns: [
                    {
                        dataField: "accountNumber", caption: "Account Number", groupIndex: 0, visible: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            var labelText = this.buildLink(item.accountId, item.accountName, item.accountNumber, item.advisorUserName, 'account');
                            labelText += `<br/> Investors: `;
                            for (var i = 0; i < item.investors.length; i++) {
                                labelText += this.buildLink(item.investors[i].id, item.investors[i].fullName, undefined, item.advisorUserName, 'investor');
                                if (i + 1 < item.investors.length)
                                    labelText += ", ";
                            }

                            labelText += `<br/> Households: `;

                            for (var j = 0; j < item.households.length; j++) {
                                var hh = item.households[j];
                                labelText += this.buildLink(hh.id, hh.name, undefined, item.advisorUserName, 'household');
                                if (j + 1 < item.households.length)
                                    labelText += ", ";
                            }

                            if (item.productName)
                                labelText += `<br/> Product: ${item.productName}`;
                            $('<div>').html(labelText).appendTo(groupCell);
                            this.$compile(groupCell.contents())(this.$scope);
                        }
                    },
                    {
                        dataField: "accountName", caption: "Account", width: 300, cellTemplate: (cellElement, item) => {
                            var labelText = this.buildLink(item.data.accountId, item.data.accountName, item.data.accountNumber, item.data.advisorUserName, 'account');
                            $('<div>').html(labelText).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    },
                    { name: "accountNumber2", dataField: "accountNumber", caption: "Number", allowFiltering: true },
                    { dataField: "titleType", caption: "Type" },
                    { dataField: "companyName", caption: "Company Name"},
                    { dataField: "productDescription", caption: "Product Description", allowFiltering: true, width: 400 },
                    { dataField: "managerName", caption: "Manager", allowFiltering: true },
                    { dataField: "productName", caption: "Product Name", allowFiltering: true, width: 200 },
                    { dataField: "modelName", caption: "Model", allowFiltering: true },
                    { dataField: "securityName", caption: "Security", allowFiltering: true, width: 400 },
                    { dataField: "uniqueSecId", caption: "Security ID", allowFiltering: true },
                    { dataField: "usdMarketValue", caption: "Amount", format: "currency", allowHeaderFiltering: false },
                    { dataField: "asOfDate", caption: "As of Date", dataType: "date", format: "MM/dd/yyyy" },
                    {
                        dataField: "advisorName", caption: "Advisor", visible: !this.isAdvisor, cellTemplate: (cellElement, item) => {
                            var labelText = this.buildAdvisorLink(item.data.advisorName, item.data.advisorUserName);
                            $('<div>').html(labelText).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }
                    },
                    {
                        caption: "Investors", cellTemplate: (cellElement, item) => {
                            var account: domains.IAccountBOAccountData = item.data;
                            var reducedLabel = account.investors.reduce((label, investor) => {
                                return label != "" ? label + ", " + this.buildLink(investor.id, investor.fullName, undefined, account.advisorUserName, 'investor') :
                                    this.buildLink(investor.id, investor.fullName, undefined, account.advisorUserName, 'investor');
                            }, "");
                            $('<div>').html(reducedLabel).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    },
                    {
                        caption: "Households", cellTemplate: (cellElement, item) => {
                            var account: domains.IAccountBOAccountData = item.data;
                            var reducedLabel = account.households.reduce((label, household) => {
                                return label != "" ? label + ", " + this.buildLink(household.id, household.name, undefined, account.advisorUserName, 'household') :
                                    this.buildLink(household.id, household.name, undefined, account.advisorUserName, 'household');
                            }, "");
                            $('<div>').html(reducedLabel).appendTo(cellElement);
                            this.$compile(cellElement.contents())(this.$scope);
                        }, allowHeaderFiltering: false
                    }
                ],
                summary: {
                    groupItems: [{
                        column: "usdMarketValue", name: "sumAmount", summaryType: "sum",
                        alignByColumn: true, displayFormat: "{0}", valueFormat: "currency"
                    }]
                },
                sortByGroupSummaryInfo: [{ sortOrder: "desc", summaryItem: "sumAmount" }],
                onInitialized: e => {
                    this.dgSummary = e.component;
                    this.showAdvisorColumn(e.component);
                }
            };
        }

        setupPivotGrid() {
            this.pgAllResultsOptions = {
                bindingOptions: {
                    dataSource: "vm.pgdsoAllResults"
                },
                stateStoring: {
                    enabled: true,
                    storageKey: "searchPivotGrid"
                },
                export: {
                    enabled: true,
                },
                allowFiltering: true,
                allowSorting: true,
                allowSortingBySummary: true,
                fieldChooser: {
                    allowSearch: true,
                },
                fieldPanel: {
                    visible: true,
                },
                headerFilter: {
                    allowSearch: true,
                    searchTimeout: 500
                },
                scrolling: {
                    mode: 'virtual',
                    useNative: true
                },
                onInitialized: (e) => {
                    this.pgAllResults = e.component;
                }
            }
        }

        buildCustomExportCell(options) {
            var excelDataGridCell = options.gridCell;
            if (excelDataGridCell.rowType == "data") {
                if (excelDataGridCell.column.caption == "Investors") {
                    options.value = excelDataGridCell.data.investors.reduce((label, investor) => {
                        return label != "" ? label + ", " + investor.fullName : investor.fullName;
                    }, "");
                } else if (excelDataGridCell.column.caption == "Households") {
                    options.value = excelDataGridCell.data.households.reduce((label, households) => {
                        return label != "" ? label + ", " + households.name : households.name;
                    }, "");
                }
            }
        }

        escapeQuotes(quotes: string[], value: string): string {
            var result = value;
            quotes.forEach(q => {
                var escpQuote = '\\' + q;
                result = result.replace(q, escpQuote);
            })
            return result;
        }

        buildLink(id: number, name: string, number: string, advisorUserName: string, to: linkTo): string {
            var link = "";
            var displayName = this.escapeQuotes(["`"], name);
            if (number != undefined) {
                displayName += ` (${this.escapeQuotes(["`"], number)})`
            }

            var path = linkPath[to];
            var func = linkFunction[to];
            if (this.isAdvisor) {
                link = `<a href="${path}"${id}" > ${displayName}</a>`;
            } else {
                link = `<a ng-click="${func}('${this.escapeQuotes(["'", "\"", "`"], name)}',${id},'${this.escapeQuotes(["'", "\"", "`"], advisorUserName)}')" href="#"> ${displayName}</a>`;
            }
            return link;
        }

        buildAdvisorLink(advisorName: string, advisorUserName: string): string {
            return `<a ng-click="vm.impersonateAdvisor('${this.escapeQuotes(["'", "\"", "`"], advisorName)}','${this.escapeQuotes(["'", "\"", "`"], advisorUserName)}')" href="#"> ${this.escapeQuotes(["`"], advisorName)}`
        }

        private impersonateAdvisorAt(advisorId: string, confirmationMsg: string, landingPage: string): void {
            //            if (this.okToImpersonateAdvisor(advisor)) {
            if (true) {
                if (window.confirm(confirmationMsg)) {
                    // authenticate servicer as advisor 
                    this.identityService.impersonateUser(advisorId)
                        .then(response => {
                            // clear localstorage
                            localStorage.clear();
                            // redirect page to advisor dashboard
                            window.location.href = landingPage;
                        }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
                }
            } else {
                //if (advisor.systemLogin.loginStatus != 1) {
                //    toastr.warning("You can only impersonate users with ACTIVE Login Status.");
                //} else {
                toastr.warning("You can not impersonate this user.");
                //                }
            }
        }

        impersonateAdvisor(advisorName: string, advisorUserName: string): void {
            this.impersonateAdvisorAt(advisorUserName, `Impersonate ${advisorName}?`, "/advisor/dashboard");
        }

        goToAccountSummary(accountName: string, accountId: number, advisorId: string): void {
            this.impersonateAdvisorAt(advisorId, `Go to account summary for ${accountName}?`, `/advisor/accountsummary/${accountId}`);
        }

        goToInvestorDashboard(investorName: string, investorId: number, advisorId: string): void {
            this.impersonateAdvisorAt(advisorId, `Go to investor dashboard for ${investorName}`, `/advisor/advisorinvestordashboard/${investorId}`);
        }

        goToHouseholdDashboard(householdName: string, householdId: number, advisorId: string): void {
            this.impersonateAdvisorAt(advisorId, `Go to household dashboard for ${householdName}`, `/advisor/advisorhouseholddashboard/${householdId}`);
        }

        reduceBoAccountDetailsToAccounts(): void {
            this.accounts = [];
            this.boAccountDetails.reduce((accounts, boAccountDetail) => {
                if (accounts.findIndex(a => a.accountId == boAccountDetail.accountId) == -1) {
                    accounts.push({
                        accountId: boAccountDetail.accountId,
                        accountName: boAccountDetail.accountName,
                        accountNumber: boAccountDetail.accountNumber,
                        accountType: boAccountDetail.accountType,
                        companyName: boAccountDetail.companyName,
                        productDescription: boAccountDetail.productDescription,
                        productName: boAccountDetail.productName,
                        modelName: boAccountDetail.modelName,
                        managerName: boAccountDetail.managerName,
                        uniqueSecId: boAccountDetail.uniqueSecId,
                        securityName: boAccountDetail.securityName,
                        titleType: boAccountDetail.titleType,
                        marketValueDate: boAccountDetail.asOfDate,
                        usdMarketValue: boAccountDetail.totalAUM,
                        advisorName: boAccountDetail.advisorName,
                        advisorId: boAccountDetail.advisorId,
                        advisorUserName: boAccountDetail.advisorUserName,
                        investors: boAccountDetail.investors,
                        households: boAccountDetail.households,
                    })
                }
                return accounts;
            }, this.accounts);
        }

        reduceBoAccountDetailsToPivotTableDetails(): void {
            let indexMap = new Map<string, number>();
            this.boAccountPivotTableDetails = [];
            this.boAccountDetails.reduce((boAccountPivotTableDetaild, boAccountDetail) => {
                var uniqueId = boAccountDetail.accountId + ";" + boAccountDetail.modelIdInt + ";" + boAccountDetail.productName + ";" + boAccountDetail.uniqueSecId + ";" + boAccountDetail.usdMarketValue;
                if (indexMap.has(uniqueId)) {
                    var i = indexMap.get(uniqueId);
                    boAccountPivotTableDetaild[i].advisorNames.push(boAccountDetail.advisorName);
                } else {
                    var i = boAccountPivotTableDetaild.push({
                        accountName: boAccountDetail.accountName,
                        accountNumber: boAccountDetail.accountNumber,
                        companyName: boAccountDetail.companyName,
                        productName: boAccountDetail.productName,
                        modelName: boAccountDetail.modelName,
                        managerName: boAccountDetail.managerName,
                        securityName: boAccountDetail.securityName?.length > 0 ? boAccountDetail.securityName : boAccountDetail.uniqueSecId,
                        asOfDate: boAccountDetail.asOfDate,
                        usdMarketValue: boAccountDetail.usdMarketValue,
                        advisorNames: [boAccountDetail.advisorName],
                        investors: boAccountDetail.investors,
                        households: boAccountDetail.households,
                    });
                    indexMap.set(uniqueId, i - 1);
                }
                return boAccountPivotTableDetaild;
            }, this.boAccountPivotTableDetails);
        }

        readResponse(data: domains.IAccountBOAccountData[]): void {
            this.boAccountDetails = data;
            this.reduceBoAccountDetailsToAccounts();
            this.reduceBoAccountDetailsToPivotTableDetails();
            //this.mainPanel.hideLoadingPanel();
            this.pgdsoAllResults.store = this.boAccountPivotTableDetails;
            this.resetSearch = false;
            this.loading = false;
        }
        // for search product widget
        onValuesSelected(boValues: Array<any>) {
            this.selectedSecurities = boValues.filter(boValue => boValue.type == domains.BoSearchResultType.Security).map(s => s.uniqueSecId);
            this.selectedManagers = boValues.filter(boValue => boValue.type == domains.BoSearchResultType.Manager).map(m => m.managerId);
            this.selectedProducts = boValues.filter(boValue => boValue.type == domains.BoSearchResultType.Product).map(p => p.managerProductId);
            this.loadAccountsByMultiSelectValues();
        }

        onProductSelected(boProduct: domains.ISecurityProductDetail): void {
            //console.log("Product has been selected: ", boProduct);
            this.selectedSecurityProduct = boProduct;
            this.loadAccountsByManagerProduct();
        }

        onBoSecuritySymbolSelected(boSecuritySymbol: domains.ISecurityProductDetail): void {
            //console.log("Product has been selected: ", boSecuritySymbol);
            this.selectedSecurityProduct = boSecuritySymbol;
            this.loadAccountsBySecId();
            //this.loadAccountsBySearchTerm(this.selectedSecurityProduct.uniqueSecId);
        };

        onFullTextSearch(searchTerm: any): void {
            this.searchTerm = searchTerm;
            this.loadAccountsBySearchTerm();
        }

        onReset(): void {
            this.accounts = [];
            this.boAccountDetails = [];
            this.boAccountPivotTableDetails = [];
            this.pgdsoAllResults.store = this.boAccountPivotTableDetails;
            this.selectedSecurityProduct = undefined;
            this.searchTerm = null;
            this.resetSearch = true;
        }

        extractData(e): any {
            var maxDepth = 5;
            var item = e;

            for (var d = 0; d < maxDepth; d++) {
                if (item.rowType === "group" && d == 0) {
                    item = item.data.items ? item.data.items[0] : item.data.collapsedItems[0];
                }
                else if ((item.items || item.collapsedItems) && d > 0) {
                    item = item.items ? item.items[0] : item.collapsedItems[0];
                }
                else if (!(item.items || item.collapsedItems) && d > 0) {
                    return item;
                }
                else if (item.rowType === "data") {
                    return item.data;
                }
            }
        }
        setupAdminFirmInfo(): any {
            const adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = adminMode && adminMode.enabled;
            const advisoryFirmId = adminModeEnabled ? adminMode.advisoryFirm.id : null;
            //this.mainPanel.showLoadingPanel();
            this.loading = true;

            return { adminModeEnabled: adminModeEnabled, advisoryFirmId: advisoryFirmId}
        }

        loadAccountsByMultiSelectValues(): void {
            const adminFirmInfo = this.setupAdminFirmInfo();

            this.boAccountDetails = [];

            this.accountApi
                .getAccountBySecuritiesManagersProducts(this.selectedSecurities, this.selectedManagers, this.selectedProducts,
                    adminFirmInfo.advisoryFirmId, adminFirmInfo.adminModeEnabled)
                .then((response) => {
                    //console.log("Accounts per uniqueSecIds, managerIds, productIds loaded...");
                    this.readResponse(response.data);
                }, error => {
                    //this.mainPanel.hideLoadingPanel();
                    this.loading = false;
                    this.generalService.showError(error);
                });
        }

        loadAccountsBySearchTerm(): void {
            this.selectedSecurityProduct = undefined;

            const adminFirmInfo = this.setupAdminFirmInfo();

            this.boAccountDetails = [];

            this.accountApi
                .getAccountsBySearchTerm(adminFirmInfo.adminModeEnabled, this.searchTerm, adminFirmInfo.advisoryFirmId)
                .then((response) => {
                    //console.log("Accounts per uniqueSecId loaded...");
                    this.readResponse(response.data);
                }, error => {
                    //this.mainPanel.hideLoadingPanel();
                    this.loading = false;
                    this.generalService.showError(error);
                });
        }

        loadAccountsBySecId(): void {
            this.searchTerm = undefined;
            const adminFirmInfo = this.setupAdminFirmInfo();

            this.boAccountDetails = [];
            this.accountApi
                .getAccountsBySecurity(adminFirmInfo.adminModeEnabled, this.selectedSecurityProduct.uniqueSecId, adminFirmInfo.advisoryFirmId)
                .then((response) => {
                    //console.log("Accounts per uniqueSecId loaded...");
                    this.readResponse(response.data);
                }, error => {
                    //this.mainPanel.hideLoadingPanel();
                    this.loading = false;
                    this.generalService.showError(error);
                });
        }

        loadAccountsByManagerProduct(): void {
            this.searchTerm = undefined;
            const adminFirmInfo = this.setupAdminFirmInfo();

            this.boAccountDetails = [];
            this.accountApi
                .getAccountsByManagerProduct(this.selectedSecurityProduct.managerId, this.selectedSecurityProduct.managerProductId, adminFirmInfo.advisoryFirmId, adminFirmInfo.adminModeEnabled)
                .then((response) => {
                    //console.log("Accounts per manager product loaded...");
                    this.readResponse(response.data);
                }, error => {
                    //this.mainPanel.hideLoadingPanel();
                    this.loading = false;
                    this.generalService.showError(error);
                });
        }

        onMainPanelInit(ctrl) {
            //this.mainPanel = ctrl;
        }

        showAdvisorColumn(dg: DevExpress.ui.dxDataGrid) {
            const adminMode = this.advisorService.getAdminMode();

            if (dg) {
                dg.columnOption("Advisor", "visible", !this.isAdvisor || adminMode.enabled);
            }
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                var user = response;
                this.isAdvisor = (user.systemLoginType == domains.SystemLoginType.ADVISOR);
                this.setupDataGrids();
                this.setupPivotGrid();
                this.onIAmReady({ ctrl: this });
            });
        }

        $onDestroy(): void {
            if (this.dgAccountsOnly) {
                this.dgAccountsOnly.dispose();
            }
            if (this.dgAllResults) {
                this.dgAllResults.dispose();
            }
            if (this.dgSummary) {
                this.dgSummary.dispose();
            }

        }

        $onChanges(evt): void {
            //for (var key in evt) {
            //}
        }
    }


    class SelectFilterSecurityCode2 implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = SelectFilterSecurityCodeController2;
            this.controllerAs = "vm";
            this.bindings = {
                "onIAmReady": "&"
            };
            this.templateUrl = "spa/shared/common/select-filter-security-code2.html";
        }
    }
    angular.module(Constants.APP).component("selectFilterSecurityCode2", new SelectFilterSecurityCode2());
}